import { render, staticRenderFns } from "./NoNavbarLayout.vue?vue&type=template&id=015e97c8&scoped=true"
import script from "./NoNavbarLayout.vue?vue&type=script&lang=js"
export * from "./NoNavbarLayout.vue?vue&type=script&lang=js"
import style0 from "./NoNavbarLayout.vue?vue&type=style&index=0&id=015e97c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015e97c8",
  null
  
)

export default component.exports